module.exports = "img/flags/BM.840a1f4.png";